import React from 'react';
import { css } from '@emotion/react';
import ProductsImage from '@images/products.svg';
import DotsImage from '@images/dots.svg';
import FrontpageLink from '@components/FrontpageLink';
import { buildUtmUrl } from '@lib/searchQuery';

export default function ProductsSection({ data }) {
  const { products } = data;
  return (
    <div>
      <div
        className="container text-center "
        css={css`
          padding-top: 6rem;
          padding-bottom: 6rem;
        `}
      >
        <div
          css={css`
            p {
              font-weight: 300;
              font-size: 2.6rem;
              margin-bottom: 8rem;

              @media (max-width: 767px) {
                margin-bottom: 3rem;
              }
            }
          `}
          dangerouslySetInnerHTML={{ __html: data.products_title }}
        />
        <div className="position-relative">
          <div
            css={css`
              display: block;
              margin: 0 auto;
              background: url(${ProductsImage});
              background-repeat: no-repeat;
              background-size: contain;
              margin-bottom: 8rem;
              padding-bottom: calc(186.16 / 272.89 * 100%);
              width: 100%;
              /* @md */
              @media (min-width: 768px) {
                padding-bottom: calc(186.16 / 272.89 * 400px);
                width: 400px;
              }
              @media (max-width: 767px) {
                margin-bottom: 3rem;
              }
            `}
          />
          <div
            className="position-absolute d-none d-md-block"
            css={css`
              display: block;
              top: 0;
              width: 100%;
              margin: 0 auto;
              background: url(${DotsImage});
              background-repeat: no-repeat;
              background-position-x: center;
              background-size: contain;
              padding-bottom: calc(160.42 / 435.37 * 670px);
              width: 100%;
              top: -70px;
              left: -30px;
            `}
          >
            <div
              css={css`
                position: absolute;
                text-align: left;
                font-size: 16px;
                top: -10px;
                left: 790px;
                width: 280px;

                /* @lg */
                @media (max-width: 1199px) {
                  left: 700px;
                  width: 230px;
                }
                /* @md */
                @media (max-width: 991px) {
                  left: 580px;

                  width: 160px;

                  font-size: 14px;
                }
              `}
            >
              <h2
                css={css`
                  font-size: 18px;
                  font-weight: bold;
                  margin-bottom: 0;
                `}
                className="text-primary text-uppercase"
              >
                {products[0].product_title}
              </h2>
              <p
                css={css`
                  text-align: justify;
                `}
              >
                {products[0].product_description}
              </p>
            </div>
            <div
              css={css`
                position: absolute;
                text-align: left;
                font-size: 16px;
                top: 260px;
                left: 850px;
                width: 280px;

                /* @lg */
                @media (max-width: 1199px) {
                  left: 725px;
                  width: 230px;
                }
                /* @md */
                @media (max-width: 991px) {
                  left: 580px;

                  width: 160px;

                  font-size: 14px;
                }
              `}
            >
              <h2
                css={css`
                  font-size: 18px;
                  font-weight: bold;
                  margin-bottom: 0;
                `}
                className="text-primary text-uppercase"
              >
                {products[1].product_title}
              </h2>
              <p
                css={css`
                  text-align: justify;
                `}
              >
                {products[1].product_description}
              </p>
            </div>
            <div
              css={css`
                position: absolute;
                text-align: left;
                font-size: 16px;
                top: 230px;
                left: 105px;
                width: 260px;

                /* @lg */
                @media (max-width: 1199px) {
                  left: 40px;
                  width: 230px;
                }
                /* @md */
                @media (max-width: 991px) {
                  left: 5px;

                  width: 160px;

                  font-size: 14px;
                }
              `}
            >
              <h2
                css={css`
                  font-size: 18px;
                  font-weight: bold;
                  margin-bottom: 0;
                `}
                className="text-primary text-uppercase"
              >
                {products[2].product_title}
              </h2>
              <p
                css={css`
                  text-align: justify;
                `}
              >
                {products[2].product_description}
              </p>
            </div>
          </div>
        </div>
        <div
          className="d-block d-md-none mb-5"
          css={css`
            p {
              margin-bottom: 1.5rem;
            }
          `}
        >
          <div>
            {' '}
            <h2
              css={css`
                font-size: 18px;
                font-weight: bold;
                text-align: left;
              `}
              className="text-primary text-uppercase"
            >
              {products[0].product_title}
            </h2>
            <p
              css={css`
                text-align: justify;
              `}
            >
              {products[0].product_description}
            </p>
          </div>
          <div>
            {' '}
            <h2
              css={css`
                font-size: 18px;
                font-weight: bold;
                text-align: left;
              `}
              className="text-primary text-uppercase"
            >
              {products[1].product_title}
            </h2>
            <p
              css={css`
                text-align: justify;
              `}
            >
              {products[1].product_description}
            </p>
          </div>{' '}
          <div>
            {' '}
            <h2
              css={css`
                font-size: 18px;
                font-weight: bold;
                text-align: left;
              `}
              className="text-primary text-uppercase"
            >
              {products[2].product_title}
            </h2>
            <p
              css={css`
                text-align: justify;
              `}
            >
              {products[2].product_description}
            </p>
          </div>
        </div>
        <div className="text-center">
          <FrontpageLink
            url={buildUtmUrl(data.link.url, 'landingpage', 'cta_button_products_section')}
            className={'btn btn-primary btn-lg'}
            text={data.link.text}
            css={css`
              color: #ffffff;
              background-color: var(--primary);
              padding: 0.2em 1em;
              border-radius: 1.25rem;
              text-transform: uppercase;
              font-weight: 600;
              font-size: 1.5rem;

              &:hover {
                text-decoration: none;
                color: #fff;
              }
            `}
          />
        </div>
      </div>
    </div>
  );
}